import { Inject, Component, Optional } from "@angular/core";

import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { BaseDetailItemComponent } from "../shared/baseDetailItemComponent";
import { GraphicsPanel, ConfGraphicsValue, GraphicsDisplayStyle, ConfUIItem, VisualObject, GroupConfUIItem } from "../../../shared/models";
import { ProductDataStore } from "../../../shared/providers/productData";

@Component({
  selector: 'graphics-detail',
  templateUrl: './graphicsDetailComponent.html',
})
export class GraphicsDetailComponent extends BaseDetailItemComponent {

  public actionBoxTitle: string;
  public showInlineTitle: boolean = false;

  public graphicPanels: Array<GraphicsPanel>;
  constructor(@Optional() @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(ProductDataStore) public productStore: ProductDataStore
  ) {
    super(confPageSessionService);
  }

  addGraphicsPanel(x: ConfUIItem) {
    const visualObject = this.productStore.getEntity(x.id);
    // We only care about render graphics, popup graphic will be shown in side menu.
    if (visualObject instanceof GraphicsPanel && visualObject.displayStyle === GraphicsDisplayStyle.Render) {
      // TODO check if visible, this code is copied from PanelVisibilityService, needs to be combined or something.
      if (visualObject.showInSummary && (!visualObject.hideEmptyPanel || this.confStore.getConfDataEntity<ConfGraphicsValue>(this.confPageSessionService.activeConfigurationId, this.confPageSessionService.confSessionId, visualObject.visualObjectId).svg))
        this.graphicPanels.push(visualObject);
    }
  }

  onDataReady(): void {
    this.graphicPanels = [];
    this.actionBoxTitle = this.strings.Graphics;

    if (this.confUIItem) {
      if (this.confUIItem.items) {
        if (this.confUIItem.id) {
          this.addGraphicsPanel(this.confUIItem);
        }
        else
          this.confUIItem.items.forEach(uiItem => {
            this.addGraphicsPanel(uiItem);
          });
      }
    }

    this.visible = this.graphicPanels.length > 0;
    if (!this.visible)
      return;

    this.showInlineTitle = this.graphicPanels.length > 1;

    if (!this.showInlineTitle) {
      let firstPanel = this.graphicPanels[0];
      if (firstPanel.title && firstPanel.title.trim().length > 0)
        this.actionBoxTitle = firstPanel.title;
      // For individually displayed panel if there is no title then hide the whole header row
      else if (typeof this.confUIItem != typeof GroupConfUIItem)
        this.showHeader = false;
    }
  }
}